var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"fab":"","outlined":"","small":"","color":"primary","elevation":"0","disabled":_vm.isActivo}},[_c('v-icon',{attrs:{"color":"primary","dense":"","size":"20px"},on:{"click":function($event){return _vm.$emit('descargar')}}},[_vm._v(" "+_vm._s(_vm.getIcono.icono)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }